<template>
  <div class="content-box-cums">
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>域名注册</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单</li>
          <li>
            <i class="step">2</i>确认订单</li>
          <li>
            <i class="step">3</i>在线支付</li>
          <li>
            <i>4</i>支付成功</li>
        </ul>
      </div>
    </div>
    <article class="wrap-pages w1200">
      <!-- <back title="订单支付"></back> -->
      <!-- <div class="con-wrap" v-show="noPay"> -->
      <div class="con-wrap"
           v-show="noPay">
        <!-- <steps :className="'mt20'" :step='2'></steps> -->
        <div class="order-detail">
          <div class="o-info clearfix">
            <div class="o-info-l fl">
              <p class="g3 f16 b"
                 v-show="false">提交成功</p>
              <p class="g3 f14">订单编号：{{payParams.orderNo}}</p>
              <p class="g3 f14">请在 <span class="red">24小时</span> 内完成支付, 超时未付款，系统将取消此订单。</p>
            </div>
          </div>
          <div class="detail-toggle">
            <div class="fl">
              <span class="f14 g7">商品数量：{{tableData.length}}件</span>
            </div>
            <div class="fr detial-btn"
                 @click="detailToggle">
              <i class="el-icon-caret-top ml10 f14 g6"
                 v-if="isShow"></i>
              <i class="el-icon-caret-bottom ml10 f14 g6"
                 v-else></i>
            </div>
            <div class="sel-pay-table"
                 v-show="isShow">
              <el-table :data="tableData"
                        style="width: 100%"
                        :show-header="true">
                <el-table-column label="产品/扩展/服务">
                  <template slot-scope="scope">
                    <div class="table-line clearfix tl">
                      <p>{{scope.row.skuName}}<em v-if="scope.row.domainNameFull">{{scope.row.domainNameFull}}</em></p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="购买数量/年限"
                                 width="200">
                  <template slot-scope="scope">
                    <div class="table-line tl">
                      <span v-if="scope.row.isSupportNum == 1">{{scope.row.productNum}}{{scope.row.numUnitName}}</span>
                      <span v-else>--</span> /
                      <span v-if="scope.row.isSupportDate == 1">{{scope.row.timeLong}}{{scope.row.timeUnitName}}</span>
                      <span v-else>--</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="单价"
                                 width="200">
                  <template slot-scope="scope">
                    <div class="table-line tl">
                      <span class="red">￥{{scope.row.basePrice | numToFix}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="小计（元）"
                                 width="200">
                  <template slot-scope="scope">
                    <div class="table-line tl">
                      <span class="red">￥{{scope.row.sumPrice | numToFix}}</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="text-tit f14 mt40 mb10 g0 b">使用余额/优惠券</div>
        <div class="cus-el-checkbox"
             v-if="isAccountPay">
          <div id="squareCheckbox"
               class="payTypeContent">
            <div class="balance mb30">
              <div class="mb15">
                <el-checkbox v-model="PAY_ACCOUNT_METHOD"
                             :disabled="(IS_PAY_ALIPAY_METHOD || onlinePayCode.accountBalance == 0) && !payForm.accountBalance"
                             @change="checkAccount">
                  <span class="deposit">使用余额账户（可用余额：<span class="orange">{{onlinePayCode.accountBalance | numToFix}}</span>元）</span>
                </el-checkbox>
                <span class="c-link text-color poi"><a class="blue"
                     :href="rechargeUrl"
                     target="_blank">充值</a></span>
              </div>
              <div class="ml25"
                   v-if="PAY_ACCOUNT_METHOD">
                <span class="mr10 g6">本次使用</span>
                <el-input-number class="w100 f12"
                                 placeholder="请输入金额"
                                 :controls="false"
                                 :precision="2"
                                 :max="maxAccountBalance"
                                 :disabled="!PAY_ACCOUNT_METHOD"
                                 @change="changeAccountBalance"
                                 v-model="payForm.accountBalance"></el-input-number>
                <span class="ml10 g6">元</span>
              </div>
            </div>
            <div class="balance mb30">
              <div class="mb15">
                <el-checkbox v-model="PAY_OFFLINE_METHOD"
                             :disabled="(IS_PAY_ALIPAY_METHOD || onlinePayCode.offlineBalance == 0) && !payForm.offlineBalance"
                             @change="checkOffline">
                  <span class="deposit">使用预存款账户（可用余额：<span class="orange">{{onlinePayCode.offlineBalance | numToFix}}</span>元）</span>
                </el-checkbox>
              </div>
              <div class="ml25"
                   v-if="PAY_OFFLINE_METHOD">
                <span class="mr10 g6">本次使用</span>
                <el-input-number class="w100 f12"
                                 placeholder="请输入金额"
                                 :controls="false"
                                 :precision="2"
                                 :max="maxOfflineBalance"
                                 :disabled="!PAY_OFFLINE_METHOD"
                                 @change="changeOfflineBalance"
                                 v-model="payForm.offlineBalance"></el-input-number>
                <span class="ml10 g6">元</span>
              </div>
            </div>
            <div class="coupon">
              <el-checkbox v-model="PAY_COUPON_METHOD"
                           :disabled="couponsOptions.length==0"
                           @change="checkCoupon">
                <span class="deposit">使用优惠券</span>
              </el-checkbox>
              <el-select v-model="couponsCode"
                         @change="handleCoupons"
                         :disabled="!PAY_COUPON_METHOD"
                         placeholder="请选择">
                <el-option v-for="item in couponsOptions"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="g6 f14"
             v-else>
          此账号无使用余额支付权限！
        </div>
        <div class="pay-password clearfix"
             v-if="PAY_ACCOUNT_METHOD || PAY_OFFLINE_METHOD || PAY_COUPON_METHOD">
          <div class="user mb20"
               v-if="PAY_ACCOUNT_METHOD || PAY_OFFLINE_METHOD">
            <span class="g6">使用余额：</span>
            <span>{{PAY_USE_BALANCE | numToFix}}元</span>
            <span class="balance-tips"
                  v-show="noEnough > 0">
              <i class="el-icon-information red ml10"></i>
              <span>余额不足，还需支付<label class="no-enough">￥{{noEnough | numToFix}}</label>元</span>
            </span>
          </div>
          <div class="f12 g6 lh30 fl">支付密码:</div>
          <div class="fl ml10"
               style="width: 200px">
            <el-input type="password"
                      v-model="password"
                      auto-complete="off"></el-input>
          </div>
          <div class="f12 g6 lh30 fl ml20"
               v-if="!isPayPassword">
            还未设置支付密码？<span class="blue poi"
                  @click="setPassword()">点此设置</span>
          </div>
        </div>
        <div class="payment-method clearfix">
          <div class="text-tit f14 g0 b">支付方式</div>
          <div class="cus-el-checkbox">
            <div class="alipay clearfix">
              <el-checkbox class="fl"
                           v-model="PAY_ALIPAY_METHOD"
                           :disabled="IS_PAY_ALIPAY_METHOD && !this.reailCost"
                           @change="checkAlipay">
                <img src="./images/zhifubao-img.jpg"
                     alt="">
              </el-checkbox>
            </div>
          </div>
          <div class="alipaymoney"
               v-show="PAY_ALIPAY_METHOD">
            <!-- <span>优惠金额：0，</span> -->
            <span>支付：</span>
            <span class="paymoney">￥{{paymentAmout | numToFix}}</span>
          </div>
        </div>
        <div class="cofirm-pay mt40 mb40 clearfix">
          <p class="g3 f12">共 <span class="red">{{tableData.length}}</span> 产品/扩展/服务</p>
          <p class="g3 mt5 f12">应付总额：
            ¥ <span class="red">{{reailCost | numToFix}}</span>
            <span>（订单总金额：{{initReailCost | numToFix}} ，优惠：{{discountCouponAmount | numToFix}}，余额支付：{{PAY_USE_BALANCE | numToFix}}）</span>
          </p>

          <div class="commit-btn mt30 ml35 fl"
               v-show="!isloading"
               :class="{'cus-disabled': valiboxBtn}"
               @click="confirmPay">去支付</div>

          <div class="fl">
            <el-button class="bg-pink noborder"
                       v-show="isloading"
                       type="primary"
                       :loading="true">加载中</el-button>
          </div>
          <div class="tips fl"
               v-show="valibox">
            <i class="el-icon-information red ml10"></i>
            <span class="red">{{valimsg}}</span>
          </div>
        </div>

        <el-dialog title="登录支付宝在线支付"
                   :visible.sync="alipayWindow"
                   class="alipay-window">
          <div class="f12 p20">
            <p class="info-time">
              <i class="el-icon-information red mr10"></i>请在
              <span class="red time-num">{{hour}}</span>小时
              <span class="red time-num">{{minute}}</span>分
              <span class="red time-num">{{second}}</span> 秒内完成支付，超时后系统将作废此订单。
            </p>
            <p class="info-code">订单编号：{{payParams.orderNo}}</p>
            <p class="info-text">请您在新打开的支付宝页面中完成支付，支付完成前请不要关闭本窗口！</p>
          </div>
          <div slot="footer"
               class="dialog-footer">
            <div class="info-ques">
              <pay-ques></pay-ques>
            </div>
            <div id="payBtnItem"
                 class="flex-box">
              <div class="flex-item-1">
                <el-button type="primary"
                           class="btn-payresult"
                           @click="goOrderList">完成支付</el-button>
              </div>
            </div>
          </div>
        </el-dialog>

        <el-dialog class=""
                   :visible.sync="verifyMobileVisible"
                   :close-on-click-modal="false"
                   width="400px"
                   title="手机验证">
          <verifyMobile v-if="verifyMobileVisible"
                        :memberSecurityInfo="memberSecurityInfo"
                        @next="next"></verifyMobile>
        </el-dialog>
        <el-dialog class=""
                   :visible.sync="payPasswordDialogVisible"
                   :close-on-click-modal="false"
                   width="400px"
                   title="设置支付密码">
          <payPassword v-if="payPasswordDialogVisible"
                       :memberSecurityInfo="memberSecurityInfo"
                       @close="payPasswordDialogVisible=false;isPayPassword=1"></payPassword>
        </el-dialog>
      </div>

      <div class="con-wrap p10"
           v-if="isPayed">
        <div class="success-wrap clearfix">
          <div class="suc-icon fl"><i class="el-icon-circle-close red"></i></div>
          <div class="suc-con fr">
            <div class="suc-line">
              <span class="fc999">&nbsp;</span>
            </div>
            <div class="suc-line f16 l-h30 pb5 b-line">
              <span class="orange f18">用户待付款订单信息不存在！!</span>
            </div>
            <div class="suc-line l-h30 mt5">
              <span class="c-orange">
                此订单有可能已经完成支付或作废，您可到订单中心查询 !
                <countdown time='30'
                           cstyle="red"
                           :url="'/'"></countdown>
              </span>
            </div>
            <div class="suc-line mt10">
              您还可以去：<br />
            </div>
            <div class="suc-line mt10 clearfix">
              <pay-success-btn :config="showConfig"></pay-success-btn>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import PayQues from "./components/private-component/PayQues";
import PaySuccessBtn from "./components/private-component/PaySuccessBtn";
import Steps from "./components/private-component/Steps";
import verifyMobile from './components/dialog-verifyMobile'
import payPassword from './components/payPassword'
import protocol from "../components/Protocol";
import merge from 'webpack-merge'
import MD5 from "md5-es";

import numToFix from "../util/num-tofix";

export default {
  data () {
    return {
      visible_protocol: false, // 用户协议弹层
      visible_zhifubao: false, // 登录支付宝弹层
      verifyMobileVisible: false, // 验证手机号弹层
      payPasswordDialogVisible: false, //设置支付密码弹层
      PRE_DEPOSIT: false,
      PAY_COUPON_METHOD: false,
      ONLINE_PAYMENT: false,
      noBalance: false,
      valibox: true,
      valimsg: '请选择支付方式！',
      alipayWindow: false,
      initReailCost: 0, //总额
      couponReailCost: 0, //优惠后金额
      discountCouponAmount: 0, //优惠金额
      accountPayPwd: '',
      isPassed: true,
      isShow: false,
      isloading: false,
      isAccountPay: true,
      tableData: [],
      isPayPassword: 0, //支付密码设置状态 0没设1射过
      payParams: {
        productName: '',
        orderNo: '',
        proName: '',
        orderTime: '',
        memberCode: '',
        orderAmount: 0
      },

      rechargeUrl: __vipOrderUrl + '/expenses/center/charge',
      memberSecurityInfo: {
        safeLevel: 0,
        isPayPassword: 0,
        bindTel: null,
        bindMail: null,
        memberCode: null
      },
      count: null,
      hour: 23,
      minute: 59,
      second: 60,
      noPay: true,
      isPayed: false,
      showConfig: {
        showPlatform: false,
        showOrderList: true,
        showAppstore: false
      },
      password: '',
      couponsCode: '',
      couponsOptions: [],
      coupons: '',
      orderCode: '',
      //新修复支付
      onlinePayCode: {
        totalBalance: 0, // 总余额
        accountBalance: 0, // 会员中心余额
        offlineBalance: 0 // 线下帐户余额
      },
      payForm: {
        accountBalance: '', // 会员中心余额使用的金额
        offlineBalance: '', // 线下帐户余额使用的金额
      },
      PAY_COUPON_METHOD: false, // 选择使用优惠券
      PAY_ACCOUNT_METHOD: false, // 选择使用线上余额
      PAY_OFFLINE_METHOD: false, // 选择使用线下余额
      PAY_ALIPAY_METHOD: false, // 选择使用支付宝
      PAY_USE_BALANCE: 0, // 使用账户支付统计金额
      histroyArry: ['accountBalance', 'offlineBalance'],
      payStorage: {
        PAY_ACCOUNT_METHOD: false,
        accountBalance: '',
        PAY_OFFLINE_METHOD: false,
        offlineBalance: ''
      }
    }
  },
  props: ['selPayParams'],
  components: {
    PayQues,
    PaySuccessBtn,
    // Steps,
    // back,
    verifyMobile,
    payPassword,
    protocol
  },
  computed: {
    IS_PAY_ALIPAY_METHOD () { // 是否可以使用
      let flag = false
      const realBalance = parseFloat(this.payForm.accountBalance || 0) + parseFloat(this.payForm.offlineBalance || 0)
      if (realBalance >= parseFloat(this.reailCost)) {
        flag = true
      }
      if (flag) {
        if (!this.paymentAmout) {
          this.PAY_ALIPAY_METHOD = false
        }
        if (!this.payForm.accountBalance) {
          this.PAY_ACCOUNT_METHOD = false
        }
        if (!this.payForm.offlineBalance) {
          this.PAY_OFFLINE_METHOD = false
        }
      }

      return flag
    },
    maxAccountBalance () {
      let balance = parseFloat(this.reailCost) - parseFloat(this.payForm.offlineBalance || 0)
      if (parseFloat(this.onlinePayCode.accountBalance || 0) <= balance) {
        balance = parseFloat(this.onlinePayCode.accountBalance || 0)
      }
      return balance
    },
    maxOfflineBalance () {
      let balance = parseFloat(this.reailCost) - parseFloat(this.payForm.accountBalance || 0)
      if (parseFloat(this.onlinePayCode.offlineBalance || 0) <= balance) {
        balance = parseFloat(this.onlinePayCode.offlineBalance || 0)
      }
      return balance
    },
    reailCost () { // 总额
      if (this.PAY_COUPON_METHOD && this.couponsCode != '') {
        return this.couponReailCost
      }
      return this.initReailCost
    },
    orderid () {
      return this.selPayParams && this.selPayParams.id
    },
    paytype () {
      if (!this.PAY_ALIPAY_METHOD && !this.PAY_ACCOUNT_METHOD && !this.PAY_OFFLINE_METHOD) {
        return '0'
      }
      if (this.PAY_ALIPAY_METHOD) {
        if (this.PAY_ACCOUNT_METHOD || this.PAY_OFFLINE_METHOD) {
          // 混合支付
          return 'MIX_PAYMENT'
        } else {
          // 支付宝支付
          return 'ONLINE_PAYMENT'
        }
      } else {
        // 余额支付
        return 'ACCOUNT_PAYMENT'
      }
    },
    returnUrl () {
      return (
        window.location.protocol + "//" + window.location.host +
        "/domain/payment/paysuccess/" +
        this.payParams.orderNo
      )
    },
    //所差余额
    noEnough () {
      return (parseFloat(this.reailCost) - parseFloat(this.PAY_USE_BALANCE)).toFixed(2)
    },
    paymentAmout () {
      // debugger
      if (this.noEnough > 0 && this.paytype == 'MIX_PAYMENT') {
        return this.noEnough
      } else if (this.paytype == 'ACCOUNT_PAYMENT') {
        return 0
      } else if (this.paytype == 'ONLINE_PAYMENT') {
        return this.reailCost
      } else {
        return 0
      }
    },
    valiboxBtn () {
      if (!this.valibox) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    reailCost: {
      handler: (v, ov) => {
        if (this.payParams) {
          this.payParams.orderAmount = v
        }
      }
    },
    paytype (val, oldval) {
      this.handlePaytype(val)
    },
    'payForm.accountBalance' (n, o) {
      this.PAY_USE_BALANCE = this.payForm.offlineBalance + n
    },
    'payForm.offlineBalance' (n, o) {
      this.PAY_USE_BALANCE = this.payForm.accountBalance + n
    },
    orderid () {
      this.update()
    }
  },
  methods: {
    f (i, n) {
      if (i > 1) {
        return
      }
      let index = this.histroyArry[i]
      let key = this.payForm[index] || this[index]

      if (parseFloat(key || 0) > n) {
        this.payForm[index] = parseFloat(key || 0) - n
      } else {
        this.payForm[index] = 0
        this.f(++i, n - parseFloat(key || 0))
      }
    },
    handlePaytype (val) {
      switch (val) {
        case "0":
          this.valibox = true;
          this.valimsg = "请选择支付方式！";
          this.enough = false;
          break;
        case "ACCOUNT_PAYMENT":
          let valimsg

          if (this.PAY_ACCOUNT_METHOD || this.PAY_OFFLINE_METHOD) {
            valimsg = '请输入支付金额'
          } else {
            valimsg = "您的余额不足！"
          }
          if (this.noEnough > 0) {
            this.valibox = true;
            this.valimsg = valimsg
          } else {
            this.valibox = false;
          }
          this.enough = false;
          break;
        case "ONLINE_PAYMENT":
          this.valibox = false;
          this.enough = false;
          break;
        case "MIX_PAYMENT":
          if (this.noEnough < 0) {
            this.valibox = true;
            this.valimsg = "账户余额足够支付！";
            this.enough = true;
          } else {
            this.valibox = false;
            this.enough = false;
          }
          break;
      }
    },
    init () {
            if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'domain'
      ) {
        return
      }
      $.get(__consoleURL + '/api-platform/permission/userPermission').then((response) => {
        if (response.list.indexOf("UC_Operation_AccountPay") >= 0) {
          this.isAccountPay = true;
        } else {
          this.isAccountPay = false;
        }
      })
      this.update();
    },
    getCoupons () {
      let _this = this
      $.get(__shopURL + '/security/marketing/findPromotions', { orderCode: this.orderCode }).then((res) => {
        if (Object.keys(res.coupons).length == 0) return
        Object.keys(res.coupons).forEach(item => {
          _this.couponsOptions.push({
            label: res.coupons[item].couponVo.couponName,
            code: res.coupons[item].couponVo.couponCode,
            value: res.coupons[item].couponDetail.id
          })
        })
      })
      console.log(_this.couponsOptions)
    },
    update () {
      let params = {};
      params.orderid = this.$route.params.orderid;

      // params.orderid = 'f98d9bb46bb011e8874f005056837eb8'
      $.get("/order/domainsettlement", params)
        .then(response => {
          this.noPay = true;
          let data = response.order;
          if (data) {
            this.orderCode = data.orderCode
            this.initReailCost = data.reailCost
            //修改支付  
            this.onlinePayCode = {
              totalBalance: response.totalBalance, // 账户总余额
              accountBalance: response.predeposit, // 会员中心余额
              offlineBalance: response.offlineAccountBalance // 线下帐号余额
            }

            data.orderItemList.forEach(element => {
              element.orderItemAttrList.forEach(v => {
                if (v.attrCode == 'DOMAIN_FULL_NAME') {
                  element.domainNameFull = v.attrValue
                }
              })
            });
            this.tableData = data.orderItemList;
            this.payParams.productName = this.tableData[0].goodsName;
            this.payParams.orderNo = data.orderCode;
            this.payParams.orderTime = data.createTime;
            this.payParams.memberCode = data.memberCode;
            this.getCoupons()
          }
        }, (error => {
          this.noPay = false;
          if (error.status == "205") this.isPayed = true;
        })
        )

    },

    next () {
      this.verifyMobileVisible = false
      this.payPasswordDialogVisible = true
    },
    checkAccount (val) { // 选择线上账户余额支付
      if (val) {
        this.PAY_USE_BALANCE = parseFloat(this.PAY_USE_BALANCE) + parseFloat(this.payForm.accountBalance ? this.payForm.accountBalance : 0)
      } else {
        this.PAY_USE_BALANCE = parseFloat(this.PAY_USE_BALANCE) - parseFloat(this.payForm.accountBalance ? this.payForm.accountBalance : 0)
        this.payForm.accountBalance = ''
      }
      this.handlePaytype(this.paytype)
    },
    checkOffline (val) { // 选择线下账户余额支付
      if (val) {
        this.PAY_USE_BALANCE = parseFloat(this.PAY_USE_BALANCE) + parseFloat(this.payForm.offlineBalance ? this.payForm.offlineBalance : 0)
      } else {
        this.PAY_USE_BALANCE = parseFloat(this.PAY_USE_BALANCE) - parseFloat(this.payForm.offlineBalance ? this.payForm.offlineBalance : 0)
        this.payForm.offlineBalance = ''
      }
      this.handlePaytype(this.paytype)
    },
    checkAlipay (val) {
      this.handlePaytype(this.paytype)
    },
    changeAccountBalance (val) {
      // debugger
      if (this.PAY_ACCOUNT_METHOD) {
        this.PAY_USE_BALANCE = parseFloat(val ? val : 0) + parseFloat(this.payForm.offlineBalance ? this.payForm.offlineBalance : 0)
      } else {
        this.PAY_USE_BALANCE = parseFloat(val ? val : 0) - parseFloat(this.payForm.offlineBalance ? this.payForm.offlineBalance : 0)
      }
      this.histroyArry.splice(this.histroyArry.indexOf('accountBalance'), 1)
      this.histroyArry.unshift('accountBalance')
      this.handlePaytype(this.paytype)
    },
    changeOfflineBalance (val) {
      if (this.PAY_OFFLINE_METHOD) {
        this.PAY_USE_BALANCE = parseFloat(this.payForm.accountBalance ? this.payForm.accountBalance : 0) + parseFloat(val ? val : 0)
      } else {
        this.PAY_USE_BALANCE = parseFloat(this.payForm.accountBalance ? this.payForm.accountBalance : 0) - parseFloat(val ? val : 0)
      }
      this.histroyArry.splice(this.histroyArry.indexOf('offlineBalance'), 1)
      this.histroyArry.unshift('offlineBalance')
      this.handlePaytype(this.paytype)
    },
    checkCoupon () {
      if (!this.PAY_COUPON_METHOD) {
        this.couponsCode = ''
        this.PAY_ACCOUNT_METHOD = this.payStorage.PAY_ACCOUNT_METHOD
        this.PAY_OFFLINE_METHOD = this.payStorage.PAY_OFFLINE_METHOD
        if (this.noEnough > 0) {
          this.PAY_ALIPAY_METHOD = true
        } else {
          this.PAY_ALIPAY_METHOD = false
        }
        this.payForm.accountBalance = this.payStorage.accountBalance
        this.payForm.offlineBalance = this.payStorage.offlineBalance
      }
      this.discountCouponAmount = 0
    },
    handleCoupons () {
      let coupons = []
      this.couponsOptions.forEach(item => {
        if (item.value == this.couponsCode) {
          coupons.push({
            id: item.value,
            code: item.code
          })
        }
      })
      this.coupons = JSON.stringify({ coupons: coupons })
      this.useCoupons()
    },
    useCoupons () {
      let params = {
        paramData: {
          "orderCode": this.orderCode,
          "coupons": []
        }
      }
      let coupons = JSON.parse(this.coupons).coupons
      coupons.forEach(item => {
        params.paramData.coupons.push({ id: item.id })
      })

      $.get(__shopURL + "/security/marketing/calculatePromotions", { paramData: JSON.stringify(params.paramData) }).then(res => {
        this.payStorage = {
          PAY_ACCOUNT_METHOD: this.PAY_ACCOUNT_METHOD,
          accountBalance: this.payForm.accountBalance,
          PAY_OFFLINE_METHOD: this.PAY_OFFLINE_METHOD,
          offlineBalance: this.payForm.offlineBalance
        }
        this.couponReailCost = res.discountCost
        this.discountCouponAmount = res.discountCouponAmount
        let aa = res.baseCost - parseFloat(this.payForm.accountBalance || 0) - parseFloat(this.payForm.offlineBalance || 0)
        if (this.onlinePayCode.accountBalance == 0 && this.onlinePayCode.offlineBalance == 0) {
          return
        } else {
          this.f(0, parseFloat(res.discountCouponAmount) - aa)
        }
      })
    },
    payFuc () {
      let payApi, params, newPage

      if (this.PAY_ALIPAY_METHOD) {
        payApi = __consoleURL + '/api-portal/security/account/PaymentGateway'
      } else {
        payApi = __consoleURL + '/api-portal/security/account/balancePaymentGateway'
      }
      if (this.paytype == 'MIX_PAYMENT') {
        newPage = window.open()
        params = {
          orderNo: this.payParams.orderNo,
          payFlag: '2',
          payCode: '002',
          returnUrl: this.returnUrl,
          accountAmount: this.PAY_ACCOUNT_METHOD ? this.payForm.accountBalance : null,
          onlineAmount: this.paymentAmout,
          balance: this.PAY_OFFLINE_METHOD ? this.payForm.offlineBalance : null,
          data: this.coupons
        }
      } else if (this.paytype == 'ACCOUNT_PAYMENT') {
        params = {
          orderNo: this.payParams.orderNo,
          payFlag: '2',
          payCode: '002',
          returnUrl: this.returnUrl,
          accountAmount: this.PAY_ACCOUNT_METHOD ? this.payForm.accountBalance : null,
          onlineAmount: null,
          balance: this.PAY_OFFLINE_METHOD ? this.payForm.offlineBalance : null,
          data: this.coupons
        }
      } else {
        newPage = window.open()
        params = {
          orderNo: this.payParams.orderNo,
          payFlag: '2',
          balance: null,
          payCode: '002',
          returnUrl: this.returnUrl,
          onlineAmount: this.paymentAmout,
          accountAmount: null,
          data: this.coupons
        }
      }
      $.post(payApi, params).then(response => {
        if (response && response.flag == 'alipay') {
          let form = response.paymentGateway
          newPage.location.href = '/domain/payment/alipay?html=' + form
        }
        if (response && response.flag == 'balance') {
          this.$router.push({
            path: '/domain/payment/paysuccess',
            params: {
              ordercode: this.payParams.orderNo,
              status: 'success'
            }
          })
        }
      })
    },
    confirmPay () {
      if (this.valibox) return;
      if (this.valiboxBtn) return;
      this.isloading = true;
      switch (this.paytype) {
        case 'ACCOUNT_PAYMENT':
          break;
        case 'ONLINE_PAYMENT':
          this.alipayWindow = true;
          this.countdown()
        case 'MIX_PAYMENT':
          this.alipayWindow = true;
          this.countdown()
      }
      this.isloading = false;
      if (this.paytype == "ACCOUNT_PAYMENT") {
        if (this.password == "") {
          this.$message.error("请输入支付密码");
          return;
        } else {
          $.post(__consoleURL + '/api-portal/security/account/checkAccountPayPwd', {
            accountPayPwd: MD5.hash(this.password)
          }).then(response => {
            if (response.status) {
              this.$message.error("请输入正确的支付密码");
              return;
            } else {
              this.payFuc()
            }
          });
        }
      } else {
        this.payFuc()
      }
    },
    //倒计时
    countdown () {
      var _this = this;
      clearInterval(this.count);
      this.count = setInterval(function () {
        //如果窗口已关闭，计时器清除
        if (_this.alipayWindow == false) {
          clearInterval(_this.count);
          _this.hour = 23;
          _this.minute = 59;
          _this.second = 59;
          return;
        }

        if (_this.hour == 0 && _this.minute == 0 && _this.second == 0) {
          clearInterval(_this.count);
          return;
        }

        if (_this.minute == 0 && _this.second == 0) {
          _this.second == 59;
          _this.minute == 59;
          _this.hour -= 1;
          return;
        }

        if (_this.second == 0) {
          _this.second = 59;
          _this.minute -= 1;
          return;
        }
        _this.second -= 1;
      }, 1000);
    },
    detailToggle () {
      this.isShow = !this.isShow;
    },
    goOrderList () {
      this.alipayWindow = false;
      this.$emit("closePayDialog");
      window.location.href = __vipOrderUrl + '/expenses/order-list/1'
    },
    changeChecked (v) {
      this.acceptAgreement = v;
    }
  },
  filters: {
    numToFix
  },
  mounted () {
    this.init();
    let _this = this;

    $.get(__consoleURL + "/api-portal/security/member/memberSecurityInfo").then(data => {
      _this.memberSecurityInfo = merge(_this.memberSecurityInfo, data)
      _this.isPayPassword = data.isPayPassword
    })
  }
};
</script>
<style lang="scss">
@import "../../static/css/payment.scss";
</style>

<style scoped>
.content-box-cums {
  overflow: auto;
}

.wrap-pages {
  padding: 0 20px;
  background-color: #fff;
  font-family: "Microsoft Yahei";
  font-size: 12px;
}

.balance {
  position: relative;
}

.payment-method {
  margin-top: 20px;
  padding: 20px 0 40px 0;
  border-top: 1px solid #f2f2f2;
}

.deposit {
  margin: 0;
  font-size: 12px;
}

.coupon .el-select {
  margin-left: 10px;
}

.alipay {
  position: relative;
  margin-top: 40px;
}

.alipay img {
  position: absolute;
  left: 35px;
  top: -13px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.payType {
  background: #e2e2e2;
  line-height: 35px;
  padding-left: 20px;
}

.payTypeContent {
  overflow: hidden;
}

.payTypeContent > div {
  margin: 10px 0;
}

.paymoney {
  color: red;
  font-size: 18px;
}

.payTypeContent .user {
  margin-left: 25px;
  font-size: 12px;
  color: #ff4136;
}

.alipaymoney {
  margin: 20px 0 0 35px;
}

.pay-type {
  margin-top: 20px;
}

.pay-type .pay-tit {
  width: 132px;
  height: 46px;
  line-height: 46px;
  border-top: 1px solid #f0f0f0;
  border-left: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  background: #fff;
  position: relative;
  z-index: 1;
  text-align: center;
}

.pay-type .pay-con {
  border: 1px solid #f0f0f0;
  margin: -1px 0 0 0;
  padding: 30px 20px;
}

.pay-type .pay-con .pay-item {
  width: 280px;
  height: 40px;
  margin: 0 0 15px 0;
  float: left;
}

.order-detail {
  margin: 40px 0 0 0;
}

.sel-pay-table {
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  z-index: 999;
  font-size: 12px;
}

.o-info {
  margin: 0 0 40px 0;
}

.o-info .o-info-l p {
  margin: 0;
  line-height: 24px;
}

.o-table-tit {
  height: 40px;
  line-height: 40px;
  background: #ebecf0;
  border: 1px solid #e0e0e0;
  margin: 0 0 -1px 0;
  box-sizing: border-box;
  padding: 0 20px;
}

.t-item {
  height: 13px;
  line-height: 13px;
  border-right: 1px solid #d2d2d3;
  padding: 0 30px 0 0;
  margin: 0 30px 0 0;
}

.t-item:last-child {
  border-right: none;
}

.tips {
  margin: 40px 0 0 20px;
}

.time-num {
  margin: 0 5px;
}

.info-code {
  font-weight: bold;
  margin: 30px 0 10px 10px;
}

.info-text {
  margin: 0 0 0 10px;
}

.dialog-footer {
  position: relative;
  width: 100%;
}

.info-ques {
  display: inline-block;
  position: absolute;
  width: 100px;
  top: 13px;
  right: 120px;
}

.detail-toggle {
  height: 50px;
  line-height: 50px;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  border-radius: 2px;
  cursor: pointer;
  text-align: right;
  padding: 0 20px;
  position: relative;
}

.detial-btn {
  color: #4d91e4;
}

.success-con {
  text-align: center;
  width: 100%;
}

.success-box {
  border: 1px solid #ccc;
  padding: 80px 0;
  margin: 120px 0;
}

.s-tip {
  position: relative;
  text-align: center;
  margin: 0 0 50px 0;
}

.s-tip i {
  font-size: 24px;
  margin: 0 10px 0 0;
}

.s-tip span {
  display: inline-block;
  font-size: 24px;
  color: #f87500;
  height: 24px;
  line-height: 24px;
}

.item-line {
  font-size: 14px;
  margin: 15px 0;
  width: 100%;
}

.b-button {
  width: 150px;
  height: 36px;
  line-height: 36px;
  color: #0085d0;
  border: 1px solid #0085d0;
  text-align: center;
  border-radius: 3px;
  margin-top: 10px;
  cursor: pointer;
}

.time-line {
  border-top: 1px dashed #eee;
  padding: 20px 0 50px 0;
  margin: 20px 0 0 0;
}

.commit-btn {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  border-radius: 3px;
  font-size: 16px;
  background: #409eff;
}
.table-line {
  font-size: 12px;
}
.table-line p {
  margin: 0;
  line-height: 20px;
}
.table-line p em {
  background: #cccccc;
  font-style: normal;
  border-radius: 5px;
  margin-left: 5px;
  padding: 0 5px;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 450px;
}
.suc-icon {
  position: relative;
  text-align: center;
  margin: 0 0 50px 0;
}

.suc-icon i {
  font-size: 50px;
  color: #7adc23;
  margin: 0 10px 0 0;
}

.success-wrap {
  width: 450px;
  margin: 0 auto;
  padding: 120px 0 0 0;
}

.suc-icon {
  width: 50px;
  height: 50px;
}

.suc-con {
  width: 380px;
}

.iconfont {
  font-size: 14px;
}

.cus-disabled {
  background: #ccc !important;
  cursor: not-allowed !important;
  border: none !important;
}
</style>
<style>
.cus-el-checkbox .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #666666;
}
.el-input-number.w100 {
  width: 100px;
}
.sel-pay-table .el-table {
  border: 1px solid #dcdcdc;
}

.sel-pay-table .el-table thead th {
  background: #f2f2f2;
  height: 36px;
  line-height: 36px;
}

.sel-pay-table .el-table .cell,
.sel-pay-table .el-table th div,
.sel-pay-table .el-table--border th:first-child .cell {
  font-size: 14px;
  color: #666;
}

.pay-password {
  margin: 60px 0 0 0;
  padding: 20px 0 0 0;
  border-top: 1px solid #f2f2f2;
}
.blue {
  color: #2290e8;
}
</style>



// WEBPACK FOOTER //
// src/Payment/selPay.vue